import * as yup from 'yup';

const MAX_MPS = 1000;
const MAX_KEYWORDS = 50;
const MAX_KEYWORD_LENGTH = 160;

export interface IMockInboundKeyword {
  keyword: string;
  percent: number;
}

export interface ITestMockCampaignInboundMessagesCreateRequest {
  campaignId: string;
  keywords: IMockInboundKeyword[];
  mps: number;
}

export interface ITestMockCampaignInboundMessagesCreateResponse {
  enqueuedCount: number;
}

export const iTestMockCampaignInboundMessagesCreateRequestSchema = yup.object().shape({
  campaignId: yup.string().uuid('campaignId must be a UUID').required('campaignId is required'),
  keywords: yup.array()
    .of(
      yup.object().shape({
        keyword: yup.string()
          .max(MAX_KEYWORD_LENGTH, `keyword must be <= ${MAX_KEYWORD_LENGTH} characters`)
          .required('keyword is required'),
        percent: yup.number()
          .typeError('percent must be a number')
          .min(0, 'percent must be >= 0')
          .max(1, 'percent must be <= 1')
          .required('percent is required')
      })
    )
    .min(1, 'keywords must contain at least one entry')
    .max(MAX_KEYWORDS, `keywords must contain at most ${MAX_KEYWORDS} entries`)
    .required('keywords is required')
    .test('sum-percent', 'sum of keyword percents must be <= 1', keywords => {
      if (!keywords?.length) {
        return true;
      }
      const totalPercent = keywords.reduce((runningTotal, item) => runningTotal + (item?.percent ?? 0), 0);
      // Tolerate IEEE 754 accumulation error so percents that mathematically sum to 1 (e.g., 0.1 + 0.2 + 0.3 + 0.4) aren't rejected.
      return totalPercent <= 1 + 1e-9;
    }),
  mps: yup.number()
    .integer('mps must be an integer')
    .positive('mps must be > 0')
    .max(MAX_MPS, `mps must be <= ${MAX_MPS}`)
    .required('mps is required')
});
